// Autogenerated file
export const scenarioAnswerValueTypesEnum = {
    String: "String",
    Integer: "Integer",
    Double: "Double",
    DateTime: "DateTime",
    File: "File",
    TimeSpan: "TimeSpan",
    Date: "Date",
    QrCode: "QrCode",
};
export const scenarioAnswerValueTypes = [
    { label: "Строка", value: "String" },
    { label: "Целое число", value: "Integer" },
    { label: "Число с точкой", value: "Double" },
    { label: "Дата и время", value: "DateTime" },
    { label: "Файл", value: "File" },
    { label: "Время", value: "TimeSpan" },
    { label: "Дата", value: "Date" },
    { label: "QR-код", value: "QrCode" },
];
